var c10notify = {
    notify(notification, t) {
        var n = document.createElement('div');
        n.classList.add('c10notifyfadeIn');
        n.classList.add('bg-light');
        n.classList.add('text-dark');
        n.innerHTML = notification;
        document.body.appendChild(n);
        setTimeout(() => {
            n.remove();
        }, typeof t == 'number' ? t : 5000);
    }
}

var n = document.createElement('style');
n.innerText = "@keyframes c10notifyfadeIn {0% {opacity: 0;}100% {opacity: 1;}}.c10notifyfadeIn {position: fixed;top:40px;right: 20px;padding: 10px 20px 10px 20px;animation: c10notifyfadeIn 1s;z-index: 5000;}";
document.head.appendChild(n);

var c10localizer = {
    defaultLocale: 'en',

    init: function (fn) {
        this._started = true;
        //this.gdprConsent();
    },

    gdprConsent: function () {
        if (!this._started) return;
        var value = localStorage.getItem('gdprApproved');
        if (value == true || value == 'true') return this.gdprConsentAccepted();
        var data = c10localizer.getlang(c10localizer_lang);
        if (!data) return console.log('c10localizer.gdprConsent Error: No gdpr data provided for locale.');
        this._gdpr_ph = document.createElement('div');
        var html = c10localizer_template['gdprConsent'];
        for (var key in data) html = html.replace("{{" + key + "}}", data[key]);
        this._gdpr_ph.innerHTML = html;
        document.body.appendChild(this._gdpr_ph);

    },
    gdprConsentAccepted: function () {
        if (this._gdpr_ph) this._gdpr_ph.remove();
        localStorage.setItem('gdprApproved', true);
        this.gdprApproved = true;
        this.fireEvent('gdprApproved');
    },
    getHreflang: function () {
        var hreflanguages = {};
        var headTags = document.getElementsByTagName("head")[0].childNodes;
        for (var i = 0; i < headTags.length; i++) {
            var tag = headTags[i];
            if (!tag.getAttribute) continue;
            var hreflang = tag.getAttribute('hreflang');
            var href = tag.getAttribute('href');
            if (!href) continue;
            try {
                var url = new URL(tag.getAttribute('href'));
                hreflanguages[hreflang] = new URL(location.protocol + '//' + location.host + url.pathname);
            } catch (e) { }
        }
        return hreflanguages;
    },
    showLocaleNotification: function (lang) {
        //depends on c10notify.js
        if (typeof c10notify == 'undefined') return;
        if (!lang) lang = {
            en: 'This page is available in English',
            fr: 'Cette page est disponible en Français',
            es: 'Esta página está disponible en español',
            de: 'Diese Seite ist auch auf Deutsch verfügbar'
        };
        var locale = this.getLocale();
        if (this.getPageLocale() == locale) return;
        if (!lang[locale]) return;
        var hreflanguages = this.getHreflang();
        if (hreflanguages[locale]) c10notify.notify('<a href="' + hreflanguages[locale] + '" class=""><i class="bi bi-globe-europe-africa"></i> ' + lang[locale] + '</a>', 10000)
    },

    getPageLocale: function () {
        var hreflanguages = this.getHreflang();
        for (var hreflang in hreflanguages) {
            if (hreflanguages[hreflang] && new URL(hreflanguages[hreflang]).pathname == window.location.pathname) return hreflang;
        }
        return false;
    },

    getLocale: function (locale) {
        if (navigator.userLanguage) {
            this.baseLang = navigator.userLanguage.substring(0, 2).toLowerCase();
        } else {
            this.baseLang = navigator.language.substring(0, 2).toLowerCase();
        }

        if (navigator.languages && navigator.languages.length > 0)
            this.baseLang = navigator.languages[0].substring(0, 2).toLowerCase();

        if (locale)
            this.baseLang = locale;
        else
            locale = this.baseLang;

        if (!locale)
            locale = navigator.language || navigator.userLanguage;

        if (typeof defaultLocale != 'undefined') {
            locale = defaultLocale;
            this.baseLang = defaultLocale.substring(0, 2).toLowerCase();
        }

        return locale;
    },

    getbrowserlocale: function () {
        if (navigator.userLanguage) return navigator.userLanguage.substring(0, 2).toLowerCase();
        return navigator.language.substring(0, 2).toLowerCase();
    },

    getlang: function (lang, locale) {
        if (!lang || typeof lang != 'object') return false;
        if (locale && lang.hasOwnProperty(locale)) return lang[locale];
        let pageLang = this.getPageLocale();
        if (lang.hasOwnProperty(pageLang)) return lang[pageLang];
        let browserlocale = this.getbrowserlocale();
        if (lang.hasOwnProperty(browserlocale)) return lang[browserlocale];
        if (this.defaultLocale && lang.hasOwnProperty(this.defaultLocale)) return lang[this.defaultLocale];
        if ('en' && lang.hasOwnProperty('en')) return lang['en'];
        return false;
    },

    getDictionnary: function (locale, key) {
        if (!locale) locale = this.getLocale(locale);
        if (!this._dictionaries || !this._dictionaries[locale]) return false;
        if (!key) return this._dictionaries[locale];
        if (key && !this._dictionaries[locale][key]) return false;
        return this._dictionaries[locale][key];
    },

    localize: function (widgets, locale) {
        if (!locale) locale = this.getLocale(locale);
        if (!this._dictionaries || !this._dictionaries[locale] || !this._dictionaries[locale]['selectors']) return;

        var dictionary = this.getDictionnary('selectors');
        if (!dictionary) return;

        if (!widgets)
            widgets = [document];

        if (dictionary) {
            for (var i = 0; i < fr.length; i++) {
                var widget = widgets[i];
                for (var key in dictionary) {
                    if (!dictionary.hasOwnProperty(key)) continue;
                    var properties = dictionary[key];
                    var elements = widget.querySelectorAll(key);
                    for (var index = 0; index < elements.length; index++) {
                        var element = elements[index];
                        for (var property in properties) {
                            if (!properties.hasOwnProperty(property)) continue;
                            if ((property == 'html' || property == 'text') && element.hasOwnProperty('innerHTML')) {
                                element.innerHTML = properties[property];
                                continue;
                            }
                            element.setAttribute(property, properties[property]);
                        }
                    }
                }
            }
        }
    },

    getString: function (key) {
        var dictionary = this.getDictionnary();
        if (!dictionary) return;

        var defaultString = '';

        if (dictionary.hasOwnProperty(key))
            defaultString = dictionary[key];

        return defaultString;
    },

    extend: function (o) {
        for (p in o) {
            if (!o.hasOwnProperty(p)) continue;
            if (/^_*/.test(p)) {
                if (p in this)
                    //to be tested
                    Object.assign(this[p], o[p]);
                else
                    this[p] = o[p];
            }
        }
    },

    addEvent: function (name, cb) {
        this.events = this.events ? this.events : {};
        this.events[name] = this.events[name] ? this.events[name] : [];
        this.events[name].push(cb);
    },

    fireEvent: function (name, data) {
        if (this.events && name in this.events && Array.isArray(this.events[name])) { this.events[name].forEach(function (cb) { cb(data); }); }
    }
}

var c10localizer_lang = {
    "en": {
        "title": "GDPR Consent",
        "body": "We use cookies and collect personal information to ensure you get the best possible experience on our website. By clicking \"I Agree\", you consent to the use of all cookies as outlined in our <a href=\"/privacy-policy.html\">Privacy Policy</a>.",
        "accept": "I Agree"
    },
    "fr": {
        "title": "Consentement<br>GDPR",
        "body": "Nous utilisons des cookies pour vous garantir la meilleure expérience possible sur notre site web. En cliquant sur \"J'accepte\", vous consentez à l'utilisation de tous les cookies comme décrit dans notre <a href = \"/politique-de-confidentialite.html\">Politique de confidentialité</a>.",
        "accept": "J'accepte"
    }
};

var c10localizer_template = {
    gdprConsent: "<div id=\"gdprConsent\" style=\"z-index: 10000;position: fixed;top: 0px;bottom: 0px;left: 0px;right: 0px;background-color: rgba(250, 250, 250, 0.98);display: flex;justify-content: center;align-items: center;\">\
                    <div style=\"border-radius: 40px;background-color: #eee;margin: 20px;padding: 20px;text-align: center;max-width: 555px;\">\
                        <h1 class=\"title\" style=\"color:#555;\">{{title}}</h1>\
                        <p class=\"body\">{{body}}</p>\
                        <button class=\"button btn btn-primary\" onclick=\"c10localizer.gdprConsentAccepted()\" style=\"background-color: cornflowerblue;\">{{accept}}</button>\
                    </div >\
                </div> "
}

c10localizer.init();